
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { FileText, Sparkles } from "lucide-react";

interface ReportsHeaderProps {
  teamId?: string;
  onReportsAdded: () => void;
}

export const ReportsHeader = ({ teamId, onReportsAdded }: ReportsHeaderProps) => {
  const { t, language } = useLanguage();
  
  return (
    <header className="relative rounded-2xl p-6 sm:p-8 bg-gradient-to-br from-background/80 via-background/60 to-muted/40 border backdrop-blur-sm overflow-hidden">
      {/* Decorative accents */}
      <div className="pointer-events-none absolute -top-10 -right-10 h-40 w-40 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-10 -left-10 h-40 w-40 rounded-full bg-accent/10 blur-3xl" />

      <div className="relative z-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary">
            <FileText className="h-4 w-4" />
            <span className="text-xs font-medium">{language === "en" ? "Reports" : "Αναφορές"}</span>
          </div>

          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">
            {language === "en" ? "Report Categories" : "Κατηγορίες Αναφορών"}
          </h1>
          <p className="text-muted-foreground max-w-2xl">
            {language === "en" 
              ? "Manage custom reports, replies, emergency reports, and patrol data for your teams" 
              : "Διαχειριστείτε προσαρμοσμένες αναφορές, απαντήσεις, αναφορές έκτακτης ανάγκης και δεδομένα περιπολίας για τις ομάδες σας"}
          </p>
        </div>

        {onReportsAdded && (
          <div className="flex items-center gap-3">
            <Button onClick={onReportsAdded} className="shadow-sm">
              <Sparkles className="h-4 w-4 mr-2" />
              {language === "en" ? "Open Team Reports" : "Άνοιγμα Αναφορών Ομάδας"}
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
